import { MEDIIIA_CONTEXT_PATHS } from 'shared/constants/contextRouteMapping';

export const MEDIIIA_HOME_BANNER_CONTEXTS = [
  'artmediiia',
  'historymediiia',
  'sportmediiia',
  'eventmediiia',
  'naturemediiia',
  'aimediiia',
  'musicmediiia',
  'cinemediiia',
  'foodmediiia',
  'automediiia',
  'storiesmediiia',
  'profmediiia',
  'conceptmediiia',
] as const;

export type MediiiaHomeBannerContext = (typeof MEDIIIA_HOME_BANNER_CONTEXTS)[number];

export const isMediiiaHomeBannerContext = (
  contextName: string,
): contextName is MediiiaHomeBannerContext =>
  (MEDIIIA_HOME_BANNER_CONTEXTS as readonly string[]).includes(contextName);

type TagWithCanonical = {
  isEducationTag?: boolean;
  canonicalInfo?: {
    contextInfos?: Array<{ domain?: string }>;
  };
};

const getTagCanonicalDomain = (tag?: TagWithCanonical): string | null =>
  tag?.canonicalInfo?.contextInfos?.[0]?.domain || null;

/** Канон только с чёрного тега. */
export const getProjectBannerCanonicalDomain = (
  tags: TagWithCanonical[],
): string | null => {
  const blackTag = tags.find((tag) => tag.isEducationTag && getTagCanonicalDomain(tag));
  return getTagCanonicalDomain(blackTag);
};

/** mediiia.com/art | sport.mediiia.com → artmediiia | sportmediiia */
export const resolveMediiiaBannerContextFromDomain = (
  domain?: string | null,
): MediiiaHomeBannerContext | null => {
  if (!domain) return null;

  const cleaned = domain
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/\/+$/, '')
    .toLowerCase();

  const [host, path] = cleaned.split('/');
  const key =
    path ||
    (host === 'mediiia.com' || host.startsWith('mediiia.')
      ? null
      : host.split('.')[0]);

  if (!key) return null;

  const byPath = Object.entries(MEDIIIA_CONTEXT_PATHS).find(
    ([context, contextPath]) =>
      contextPath.replace(/^\//, '') === key && isMediiiaHomeBannerContext(context),
  )?.[0];

  if (byPath && isMediiiaHomeBannerContext(byPath)) {
    return byPath;
  }

  const byName = `${key}mediiia`;
  return isMediiiaHomeBannerContext(byName) ? byName : null;
};

export const getMediiiaBannerContext = (
  tags: TagWithCanonical[],
): MediiiaHomeBannerContext | null =>
  resolveMediiiaBannerContextFromDomain(getProjectBannerCanonicalDomain(tags));

export const getMediiiaBannerUrl = (context: MediiiaHomeBannerContext): string => {
  if (context === 'sportmediiia') {
    return process.env.REACT_APP_URL_SPORT_MEDIIIA_COM || '';
  }

  const baseUrl = process.env.REACT_APP_URL_MEDIIIA_COM || '';
  return `${baseUrl}${MEDIIIA_CONTEXT_PATHS[context] || ''}`;
};
import { MEDIIIA_CONTEXT_PATHS } from 'shared/constants/contextRouteMapping';

export const MEDIIIA_HOME_BANNER_CONTEXTS = [
  'artmediiia',
  'historymediiia',
  'sportmediiia',
  'eventmediiia',
  'naturemediiia',
  'aimediiia',
  'musicmediiia',
  'cinemediiia',
  'foodmediiia',
  'automediiia',
  'storiesmediiia',
  'profmediiia',
  'conceptmediiia',
] as const;

export type MediiiaHomeBannerContext = (typeof MEDIIIA_HOME_BANNER_CONTEXTS)[number];

export const isMediiiaHomeBannerContext = (
  contextName: string,
): contextName is MediiiaHomeBannerContext =>
  (MEDIIIA_HOME_BANNER_CONTEXTS as readonly string[]).includes(contextName);

type TagWithCanonical = {
  isEducationTag?: boolean;
  canonicalInfo?: {
    contextInfos?: Array<{ domain?: string }>;
  };
};

const getTagCanonicalDomain = (tag?: TagWithCanonical): string | null =>
  tag?.canonicalInfo?.contextInfos?.[0]?.domain || null;

/** Канон только с чёрного тега. */
export const getProjectBannerCanonicalDomain = (
  tags: TagWithCanonical[],
): string | null => {
  const blackTag = tags.find((tag) => tag.isEducationTag && getTagCanonicalDomain(tag));
  return getTagCanonicalDomain(blackTag);
};

/** mediiia.com/art | sport.mediiia.com → artmediiia | sportmediiia */
export const resolveMediiiaBannerContextFromDomain = (
  domain?: string | null,
): MediiiaHomeBannerContext | null => {
  if (!domain) return null;

  const cleaned = domain
    .replace(/^https?:\/\//i, '')
    .replace(/^www\./i, '')
    .replace(/\/+$/, '')
    .toLowerCase();

  const [host, path] = cleaned.split('/');
  const key =
    path ||
    (host === 'mediiia.com' || host.startsWith('mediiia.')
      ? null
      : host.split('.')[0]);

  if (!key) return null;

  const byPath = Object.entries(MEDIIIA_CONTEXT_PATHS).find(
    ([context, contextPath]) =>
      contextPath.replace(/^\//, '') === key && isMediiiaHomeBannerContext(context),
  )?.[0];

  if (byPath && isMediiiaHomeBannerContext(byPath)) {
    return byPath;
  }

  const byName = `${key}mediiia`;
  return isMediiiaHomeBannerContext(byName) ? byName : null;
};

export const getMediiiaBannerContext = (
  tags: TagWithCanonical[],
): MediiiaHomeBannerContext | null =>
  resolveMediiiaBannerContextFromDomain(getProjectBannerCanonicalDomain(tags));

export const getMediiiaBannerUrl = (context: MediiiaHomeBannerContext): string => {
  if (context === 'sportmediiia') {
    return process.env.REACT_APP_URL_SPORT_MEDIIIA_COM || '';
  }

  const baseUrl = process.env.REACT_APP_URL_MEDIIIA_COM || '';
  return `${baseUrl}${MEDIIIA_CONTEXT_PATHS[context] || ''}`;
};
